"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isObject = isObject;
function isObject(value) {
  const type = typeof value;
  return value !== null && (type === 'object' || type === 'function');
}
//# sourceMappingURL=isObject.js.map